import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { LyraTheme } from 'src/components/theme/lyra/Theme';
import { SWRProvider } from 'src/components/providers/swr';
import { WebsiteGraderContextProvider } from 'src/components/providers/websiteGrader';
import { ContainerForLoadingAndErrorComponents } from 'src/components/common/websiteGrader/ContainerForLoadingAndErrorComponents';
import { SuspenseFallbackLoading } from 'src/App';
import ErrorBoundary from 'src/components/common/adGenerator/ErrorBoundary';
import WebsiteGrader from 'src/pages/websiteGrader/WebsiteGrader';

export const WebsiteGraderProtectedRoute: React.FC = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const location = useLocation();

  if (!email) {
    /*
     Redirect to the website grader error page if the email query parameter is not present or has no value
     - changed error from missing_email to missing_parameter as the default message was requested for now
     */
    return <Navigate to="/website-grader/error" replace state={{ from: location, error: 'missing_parameter' }} />;
  }

  // Render the WebsiteGrader component if the email query parameter is present
  return (
    <ThemeProvider theme={{ ...LyraTheme }}>
      <SWRProvider>
        <WebsiteGraderContextProvider>
          <React.Suspense
            fallback={
              <ContainerForLoadingAndErrorComponents $aiTool={false}>
                <SuspenseFallbackLoading $aiTool={false} />
              </ContainerForLoadingAndErrorComponents>
            }
          >
            <ErrorBoundary $aiTool={false}>
              <WebsiteGrader />
            </ErrorBoundary>
          </React.Suspense>
        </WebsiteGraderContextProvider>
      </SWRProvider>
    </ThemeProvider>
  );
};
